import React, { PureComponent } from 'react';
import { Loader } from 'react-loaders';

import { getRequest, postRequest, putRequest } from "../../../../api/ApiService";

import {
  Wrapper,
  Title,
  Text,
  FormulaContainer,
  FormulaName,
  FormulaValue,
  Input,
  Button
} from '../components/ui';


class FeedbackSubmission extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      hoursToExtend: '',
      survey: null,
      pointDeductionRate: '0.00'
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    getRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/surveys/`
    )
      .then(res => {
        const surveys = res.body.results;
        let survey = null;
        let pointDeductionRate = '0.00';

        if (surveys.length) {
          survey = surveys[0];
          pointDeductionRate = Number(1 / survey.extended_time).toFixed(2);
        }

        this.setState({
          loaded: true,
          survey,
          hoursToExtend: survey.extended_time,
          pointDeductionRate
        });
      })
      .catch(err => { });
  }

  handleInputChange = e => {
    const { hoursToExtend } = this.state;
    const inputValue = Number(e.target.value);
    const inputValueFiltered = !isNaN(inputValue) ? inputValue : hoursToExtend;

    this.setState(() => ({
      hoursToExtend: inputValueFiltered
    }));
  };

  submitHoursToExtend = () => {
    const { hoursToExtend, survey } = this.state;

    putRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/surveys/update/${survey.id}/`
    ).send({
      extended_time: hoursToExtend,
      start: survey.start,
      end: survey.end
    })
      .then(() => {
        postRequest(
          `${process.env.REACT_APP_API_URL}v2/forms/surveys/${survey.id}/bulk-submission-scoring/`
        )
          .then(() => {
            this.setState({
              pointDeductionRate: Number(1 / hoursToExtend).toFixed(2)
            }, () => this.fetchData());
          })
      })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      hoursToExtend,
      survey,
      pointDeductionRate
    } = this.state;

    const extendedTime = survey ? survey.extended_time : null;
    const updateButtonDisabled = !hoursToExtend || extendedTime === Number(hoursToExtend);
    const updateButtonText = updateButtonDisabled ? 'Updated' : 'Update';
    const updateButtonTitle = updateButtonDisabled ? 'No data changes, so no updates needed.' : 'Update';

    return loaded ? (
      <Wrapper>
        <Title>Feedback Submission</Title>
        <Text>Feedback submission score is a score your students receive for submitting their final peer feedback. If they submit their final peer feedback on time, they receive 100% score. If not, they’ll receive a lower score based on the point deduction rate set below.</Text>
        <br />
        <Text>
          <p><span>Point Deduction For Late Submissions</span></p>
          <p>For students that submit their final peer evaluation late, you can set a point deduction rate that gradually reduces their feedback submission score for every hour it’s turned in late.</p>
          <p>To set up point a deduction rate,  input below the number of hours you plan to extend to students after the deadline. For example,  if you decide to provide a 2 day extension, then you’ll input 48hrs.</p>
        </Text>
        <FormulaContainer>
          <FormulaName>
            Point
            <br />
            Deduction
            <br />
            Rate
          </FormulaName>
          <FormulaValue>=</FormulaValue>
          <FormulaValue fontSize="36px" lineHeight="40">
            1
            <span className='divider' />
            <Input
              placeholder="Input # of Hours To Extend"
              equalPadding
              minWidth="195"
              min="0"
              value={hoursToExtend}
              onChange={this.handleInputChange}
            />
          </FormulaValue>
          <FormulaValue>=</FormulaValue>
          <FormulaValue fontSize="36px" lineHeight="40">
            {pointDeductionRate}
            <br />
            <Button
              type="button"
              disabled={updateButtonDisabled}
              title={updateButtonTitle}
              onClick={this.submitHoursToExtend}
            >
              {updateButtonText}
            </Button>
          </FormulaValue>
        </FormulaContainer>
      </Wrapper>
    ) : <Wrapper><Loader type="ball-scale-ripple" active /></Wrapper>;
  }

}

export default FeedbackSubmission;



// WEBPACK FOOTER //
// ./src/instructor/components/grading/pages/feedback-submission.js